import Joi from 'joi';
const blockAppearanceSchema = {
  marginTop: Joi.string().allow('', null).required(),
  marginBottom: Joi.string().allow('', null).required(),
  background: Joi.string().allow('', null).required()
};
export default blockAppearanceSchema;